import React, { useContext } from 'react';
import firebase from 'firebase/app';
import { FirebaseContext } from '.';

const SignIn = () => {
  const { auth, analytics } = useContext(FirebaseContext);

  const signInWithGoogle = (): void => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
    analytics.logEvent('login', {});
  }

  return (
    <button className='btn btn-primary' onClick={ signInWithGoogle }>Sign in with Google <i className='fab fa-google'></i></button>
  );
};

export default SignIn;
